module.exports = __webpack_public_path__ + "static/media/lamina14img.efa66171.png";